import React, { useState, useEffect, useRef } from 'react';
import MetaTags from "react-meta-tags";
import { useParams, useHistory } from 'react-router-dom';
import ApiClient from '../BaseUrl/ApiClient';
import { Button, Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';

import './BusinessDetail.css'; 
import { ToastContainer } from 'react-toastify';

function BusinessDetail() {
  const [business, setBusiness] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

    const scrollRef = useRef(null);


    

  const { businessId } = useParams();
  const history = useHistory();

  const getBusinessDetails = async () => {
    if (!businessId) {
      setError('No business ID provided');
      return;
    }

    const token = localStorage.getItem('accessToken');
    if (!token) {
      setError('Please log in');
      history.push('/login');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await ApiClient.get(`/business/admin/${businessId}`);

      setBusiness(response.data.responseData.business);
    } catch (err) {
      setError('Failed to load business details');
      if (err.response?.status === 401) {
        localStorage.removeItem('accessToken');
        history.push('/login');
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBusinessDetails();
  }, [businessId]);

  const goBack = () => {
    history.push('/business-list');
  };



  const scroll = (direction) => {
    const { current } = scrollRef;
    if (current) {
      const scrollAmount = direction === "left" ? -400 : 400;
      current.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  const renderRatingStars = (rating) => {
    const numericRating = parseInt(rating, 10) || 0;
    return Array(5).fill().map((_, i) => (
      <i
        key={i}
        className={`fas fa-star ${i < numericRating ? "filled" : ""}`}
      />
    ));
  };

  return (
     <React.Fragment>
<ToastContainer/>
          <div className="auth-page-content custom-auth-page">
            <MetaTags>
              <title>Business Detail| Findagram</title>
            </MetaTags>
      <Row>
        <Col md={12}>
          <Card>
            <CardHeader>
              <h4>Business Details</h4>
            </CardHeader>
            <CardBody>

              
              {business && (
                <div className='business-detail'>
<Row className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center bgcolor">
  <Col
    xs={12}
    md={10}
    className=""
  >
 
    <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center w-100">
      <div className="mb-3 mb-md-0 me-md-3">
        {business?.logoImage?.url ? (
          <img
            src={`${process.env.REACT_APP_LOGO_BASE_URL}/${business.logoImage.url}`}
            alt={business.logoImage?.s || "Business logo"}
            className="business-logo"
          />
        ) : (
          <div className="text-muted">No logo available</div>
        )}
      </div>

      <div className='w-100'>
        <h3 className="text-dark fw-semibold">{business.businessName || 'Business Name not found'}</h3>

        <p className="description mb-1">
          Website:{' '}
          {business.websiteLink ? (
            <a href={business.websiteLink} target="_blank" rel="noopener noreferrer">
              {business.websiteLink}
            </a>
          ) : (
            'Link not found'
          )}
        </p>

        <p className="description deswidth mb-0">
          {business.businessDescription || 'Description not found'}
        </p>
      </div>
    </div>
</Col>

 <Col
    xs={12}
    md={2}>
    <div className="mt-3 mt-md-0 ms-md-auto">
      <Button color="secondary" onClick={goBack}>
        Back to List
      </Button>
    </div>
  </Col>
</Row>




                  <Row className="mt-3">
  <Col xs={12} md={4} className="mb-2 mb-md-0">
    <p className='description'>
      <span className='rating'>Location: </span>
      {business.businessLocation?.city || ''}
      {business.businessLocation?.state ? `, ${business.businessLocation.state}` : ''}
      {business.businessLocation?.postalCode ? `, ${business.businessLocation.postalCode}` : ''}
    </p>
  </Col>

  <Col xs={12} md={4} className="mb-2 mb-md-0">
    <p className='description'>
      <span className='rating'>Average Rating:</span> {business.averageRating || '-'}
    </p>
  </Col>

  <Col xs={12} md={4}>
    <p className='description'>
      <span className='rating'>Total Reviews:</span> {business.totalReviews || '0'} 
    </p>
  </Col>
</Row>
                  <Row className="mt-3">
  <Col xs={12} md={4} className="mb-2 mb-md-0">
    <p className='description'>
      <span className='rating'>Phone Number: </span>
      {business.phone || '-'}
    </p>
  </Col>

 <Col xs={12} md={4} className="mb-2 mb-md-0">
  <p className='description'>
    <span className='rating'>Instagram:</span>{' '}
    {business.instagramId ? (
      <a
        href={`${business.instagramId}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        @{business.instagramId}
      </a>
    ) : (
      '-'
    )}
  </p>
</Col>

<Col xs={12} md={4}>
  <p className='description'>
    <span className='rating'>Telegram:</span>{' '}
    {business.telegramLink ? (
      <a
        href={business.telegramLink.startsWith('http') ? business.telegramLink : `${business.telegramLink}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {business.telegramLink}
      </a>
    ) : (
      '-'
    )}
  </p>
</Col>

</Row>
<Row className="mt-3">
  <Col xs={12} md={4} className="mb-2 mb-md-0">
  <p className='description'>
      <span className='rating'>Working Hours:</span> {business.workingHours || '-'} 
    </p>
  </Col>
</Row>

<div className="profile-section upcard subscription-section">
  <p className='description fs-18 fw-bold mt-3 text-grey-black mb-4'>Subscription Details</p>

  {business?.subscription ? (
    <div className="subscription-details">
      <Row>
        <Col xs={12} md={6}>
          <p className='description'>
            <span className='rating'>Start Date:</span> {new Date(business.subscription.subscriptionStartDate).toLocaleDateString() || '-'}
          </p>
        </Col>
        <Col xs={12} md={6}>
          <p className='description'>
            <span className='rating'>Expiry Date:</span> {new Date(business.subscription.subscriptionExpiryDate).toLocaleDateString() || '-'}
          </p>
        </Col>
      </Row>

      <Row>
        <Col xs={12} md={6}>
          <p className='description'>
            <span className='rating'>Status:</span> {business.subscription.subscriptionStatus || '-'}
          </p>
        </Col>
        <Col xs={12} md={6}>
          <p className='description'>
            <span className='rating text-capitalize'>Payment Method: </span>
            <span className='text-capitalize'>
              {business.subscription.subscriptionMethod === 'stripe' 
                ? 'Credit Card' 
                : business.subscription.subscriptionMethod || '-'}
            </span>
          </p>
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <p className='description'>
            <span className='rating'>Subscription Type: </span> 
            <span className='text-capitalize'>
              {business.subscriptionType || '-'}
            </span>
          </p>
        </Col>
      </Row>
    </div>
  ) : (
    <p className="no-subscription">No subscription information available.</p>
  )}
</div>



                   <div className="profile-section upcard ratings-section">
                  <p className='description fw-bold mt-3'>Reviews</p>
                  {business?.reviews?.length > 0 ? (
                    <div className="reviews-wrapper">
                      <button className="scroll-arrow left" onClick={() => scroll("left")}>
                        ‹
                      </button>
                      <div className="ratings-list" ref={scrollRef}>
                        {business.reviews.map((review) => (
                          <div key={review.id} className="rating-item">
                            <div className="rating-user">
                              {review.user?.firstName && review.user?.lastName
                                ? `${review.user.firstName} ${review.user.lastName}`
                                : 
                                // `User ID: ${review.userId}`
                                'Anonymous User'
                                }
                            </div>
                            <div className="rating-stars">
                              {renderRatingStars(review.rating)}
                            </div>
                            {review.comment && (
                              <div className="rating-comment">
                                <p>{review.comment}</p>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                      <button className="scroll-arrow right" onClick={() => scroll("right")}>
                        ›
                      </button>
                    </div>
                  ) : (
                    <p className="no-ratings">No reviews yet.</p>
                  )}
                </div>

                 
                </div>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
      </div>
    </React.Fragment>
  );
}

export default BusinessDetail;